import React, { Component } from "react";
import { connect } from "react-redux";

import { injectIntl, FormattedMessage } from "react-intl";

import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import "./styles.scss";

import IdealResult from "./img/correct-result.svg";

import Protein1 from "./img/protein_gel-1.svg";
import Protein2 from "./img/protein_gel-2.svg";
import Protein3 from "./img/protein_gel-3.svg";
import Protein4 from "./img/protein_gel-4.svg";
import Blank from "./img/blank-gel.svg";

const images = {
  protein1: Protein1,
  protein2: Protein2,
  protein3: Protein3,
  protein4: Protein4,
  Blank: Blank,
};

class GelResults510 extends Component {
  generateResultGel = () => {
    const renderLanes = [[], [], [], [], []];
    const renderGel = [];

    //Gets all band data for focused lane
    const bandData = this.props.resultBands;

    //Creates all bands and inserts into correct arrays in renderLanes
    for (let j = 1; j < 7; j++) {
      let counter = 0;
      for (const band in bandData["lane" + j]) {
        if (bandData["lane" + j][band] !== 0) {
          renderLanes[j - 1].push(
            <div
              className={"result-band " + band}
              style={{
                position: "absolute",
                top: bandData["lane" + j][band] * 0.2 + "px",
              }}
              key={counter * j * (j + 1)}
            ></div>
          );
        }
        counter++;
      }
    }

    //Takes all bands in renderLanes and fits them in divs in renderGel
    for (let i = 0; i < 5; i++) {
      renderGel.push(<div className={"lane-" + (i + 1)}>{renderLanes[i]}</div>);
    }

    //Returns all bands, in their divs
    return <div className="band-results">{renderGel}</div>;
  };

  render() {
    return (
      <div className="Gel510-results">
        <div className="result-prediction">
          <div className="prediction-side">
            <h4>
              <FormattedMessage
                id="Predicted results"
                defaultMessage="Predicted results"
                description=""
              />
            </h4>
            <img
              src={
                this.props.predictionProtein !== null
                  ? images[this.props.predictionProtein]
                  : images.Blank
              }
              alt={this.props.intl.formatMessage({
                id: "Top-down view of the gel cassette, showing the bands in their predicted positions.",
                defaultMessage:
                  "Top-down view of the gel cassette, showing the bands in their predicted positions.",
                description: "",
              })}
            />
          </div>
          <div className="result-side">
            <h4>
              <FormattedMessage
                id="Actual results"
                defaultMessage="Actual results"
                description=""
              />
            </h4>
            {this.generateResultGel()}
            <img
              src={images.Blank}
              alt={this.props.intl.formatMessage({
                id: "Top-down view of the gel cassette, showing the bands in their actual positions.",
                defaultMessage:
                  "Top-down view of the gel cassette, showing the bands in their actual positions.",
                description: "",
              })}
            />
          </div>
          <div className="ideal-side">
            <h4 style={{ marginTop: "16px" }}>
              <FormattedMessage
                id="Ideal results"
                defaultMessage="Ideal results"
                description=""
              />
            </h4>
            <img
              src={IdealResult}
              alt={this.props.intl.formatMessage({
                id: "Top-down view of the gel cassette, showing the bands in their correct positions.",
                defaultMessage:
                  "Top-down view of the gel cassette, showing the bands in their correct positions.",
                description: "",
              })}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    predictionProtein: state.predictions.predictionProtein,
    // TODO: Data to come from Protocol Section
    resultBands: {
      lane1: {
        10: 0,
        15: 0,
        25: 0,
        35: 0,
        45: 0,
        60: 0,
        75: 0,
        100: 0,
        140: 0,
        180: 0,
        SDS: 0,
      },
      lane2: {
        10: 0,
        15: 0,
        25: 0,
        35: 0,
        45: 0,
        60: 0,
        75: 0,
        100: 0,
        140: 0,
        180: 0,
        SDS: 0,
      },
      lane3: {
        10: 0,
        15: 0,
        25: 0,
        35: 0,
        45: 0,
        60: 0,
        75: 0,
        100: 0,
        140: 0,
        180: 0,
        SDS: 0,
      },
      lane4: {
        10: 0,
        15: 0,
        25: 0,
        35: 0,
        45: 0,
        60: 0,
        75: 0,
        100: 0,
        140: 0,
        180: 0,
        SDS: 0,
      },
      lane5: {
        10: 0,
        15: 0,
        25: 0,
        35: 0,
        45: 0,
        60: 0,
        75: 0,
        100: 0,
        140: 0,
        180: 0,
        SDS: 0,
      },
    },
  };
};

const GelResults510WithIntl = injectIntl(GelResults510);

export default connect(
  mapStateToProps,
  {}
)((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <GelResults510WithIntl {...props} />
  </TranslationsProvider>
));
